// FILE: stratify_website/src/config/site.js
export const SITE = {
  name: "Stratify Backtesting",
  legalName: "Stratify Analytics Inc.",
  appName: "Stratify - Backtesting Trading",

  brand: {
    logoText: "Stratify Backtesting",
  },

  url: "https://stratifybacktesting.com",

  supportEmail: "stratify.help@gmail.com",
  previousPublishedSupportEmail: "justen@stratifybacktesting.com",
  legalEffectiveDate: "Pending founder approval",
  supportUrl: "https://stratifybacktesting.com/support",
  privacyPolicyUrl: "https://stratifybacktesting.com/privacy-policy",
  termsUrl: "https://stratifybacktesting.com/terms-of-use",
  refundPolicyUrl: "https://stratifybacktesting.com/refund-policy",
  subscriptionTermsUrl: "https://stratifybacktesting.com/subscription-terms",
  appleSubscriptionsUrl: "https://apps.apple.com/account/subscriptions",

  tagline: "Your portfolio. Your rules.",

  description:
    "Connect your holdings with your own trading strategies. Build without code, backtest ideas, and review cloud paper trades from signal to fill.",

  keywords: [
    // brand
    "Stratify Backtesting",
    "StratifyPro",
    "Stratify Pro",
    "StratifyPro pricing",

    // your coined categories
    "strategy wallet",
    "strategy wallet pricing",
    "backtesting wallet",
    "backtesting app",
    "strategy alerts",

    // supporting intent keywords
    "backtesting",
    "trading strategies",
    "signal monitoring",
    "trading alerts",
    "paper trading",
    "iOS trading app",
    "minute data trading",
    "brokerage connection",
  ],

  appStoreUrl:
    "https://apps.apple.com/ca/app/stratify-backtesting-trading/id6749781620",
};
